// shared-components/components/base/TabFilter.jsx
import PropTypes from "prop-types";
import { cn } from "@shared/lib/utils";

/**
 * TabFilter component for responsive filtering/tab selection
 * Handles overflow gracefully on mobile without horizontal scroll
 */
function TabFilter({ tabs, activeTab, onTabChange, className = "" }) {
  // On mobile, show as a select dropdown to avoid overflow
  // On desktop, show as tabs
  return (
    <>
      {/* Mobile: Select dropdown */}
      <div className="sm:hidden">
        <select
          value={activeTab}
          onChange={(e) => onTabChange(e.target.value)}
          className={cn(
            "w-full px-4 py-2 bg-white dark:bg-gray-800",
            "border border-gray-300 dark:border-gray-700",
            "rounded-lg text-gray-900 dark:text-white",
            "focus:outline-none focus:ring-2 focus:ring-blue-500",
            className,
          )}
        >
          {tabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>

      {/* Desktop: Tab buttons */}
      <div className="hidden sm:flex sm:flex-wrap gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              "px-4 py-2 rounded-lg transition-all duration-200",
              "border-2",
              activeTab === tab.id
                ? "bg-blue-600 dark:bg-blue-500 text-white border-transparent"
                : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-700 hover:border-blue-500",
              className,
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </>
  );
}

TabFilter.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default TabFilter;
